import ServiceForm from '../../common/ServiceForm';
import React from 'react';

const RadiologyForm = (props) => (
  <ServiceForm
    {...{
      ...props,
      category: 'Radiologies',
      prefixName: 'Radiology',
      requirePlatoTestCode: true,
    }}
  />
);

export default RadiologyForm;
